// extracted by mini-css-extract-plugin
module.exports = {"tabContent":"WmIE_m","tabs":"u7z55i"};